import AttachablePaymentMethod from './AttachablePaymentMethod';
import PaymentMethodOption from './PaymentMethodOption';
import SavePaymentInfoConsent from './SavePaymentInfoConsent';

export default {
  AttachablePaymentMethod,
  PaymentMethodOption,
  SavePaymentInfoConsent,
};
